import 'css-chunksrc/client/scenes/workloads/scroll/scrollZone/styles.scss';export default {
  "scrollZone": "_scrollZone_8dyrp_1"
};